<template>
	<label>
		<em class="lt_text">Category</em>
		<span class="int_type_no_border mgr_5">
			<CodeSelect className="tbl_select sm_int" :codes="codes" v-model="code" @input="updateValue" />
		</span>
	</label>
</template>

<script>
import { apiSelectCodeList } from '@/api/basicinfo/code';
import CodeSelect from '@/components/common/CodeSelect';

export default {
	name: 'ItemClassCategory',
	data: function() {
		return {
			codes: [],
			code: '',
			active_yn: 'Y',
		};
	},
	methods: {
		async selectData() {
			const { data } = await apiSelectCodeList({
				code_type: 'ICC',
				active_yn: this.active_yn,
			});
			this.codes = data.codeList;
		},
		updateValue() {
			this.$emit('input', this.code);
		},
		reset() {
			this.code = '';
		},
	},
	components: {
		CodeSelect,
	},
	mounted() {
		this.selectData();
	},
};
</script>

<style></style>
